import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    neutral: {
      white: "#F5F5F5",
      black: "#0F110C",
    },
    grey: {
      1: "#E7E7E7",
      2: "#CBCBCB",
      3: "#EDEDED",
      4: "#f8f9fc",
    },
    primary: {
      main: "#0197f6",
      light: "#4db8ff",
      dark: "#0069c4",
      contrastText: "#ffffff",
      1: "#2e7d32",
      2: "#d32f2f",
    },
    secondary: {
      main: "#8C8C8C",
      light: "#b8b8b8",
      dark: "#5c5c5c",
      contrastText: "#ffffff",
    },
    background: {
      default: "#F5F5F5",
      paper: "#ffffff",
    },
    text: {
      primary: "#0F110C",
      secondary: "#8C8C8C",
      disabled: "#9C9C9C",
    },
    error: {
      main: "#d32f2f",
    },
    warning: {
      main: "#ed6c02",
    },
    info: {
      main: "#0197f6",
    },
    success: {
      main: "#2e7d32",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontSize: "18px",
      fontWeight: 600,
    },
    h2: {
      fontSize: "14px",
      fontWeight: 600,
    },
    body1: {
      fontSize: "12px",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export default theme;
